<template>
  <div class="wrapper">
    <h4>Offene Aufgaben</h4>
    <div class="container">
      <ul class="list-group-item">
        <li class="list-group-item d-flex justify-content-between" v-for="t in tasks" :key="t.id">
          {{ t.name }}
          <small>{{ t.created }}</small>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import services from '@/modules/services.js'

export default {
  name: 'iHandUserTasks',
  props: ["userid"],
  data() {
    return {
      tasks: [],
    }
  },
  methods: {
    updateTasks: function(handid) {
      var self = this;
      services.tasklist(this,'ihand_' + handid,function(data) {
        self.tasks = data;
      })
    }
  }
}
</script>
